export default __webpack_public_path__ + "static/main-cover-dde3aeb66c038c053678ba9a76f84795.jpeg";